export default __webpack_public_path__ + "static/media/mysteryBet.f296d879.png";